var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKinetic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.066 49.8632H79.7584C79.1776 34.9155 67.1213 22.8695 52.161 22.2891V0L0 52.1169H22.308C22.8888 67.0646 34.945 79.1107 49.9054 79.691V101.98L102.066 49.8632ZM52.161 96.5431V52.1169H96.6247L52.161 96.5431ZM78.6306 49.8632H52.161V23.416C66.501 23.9963 78.0554 35.5409 78.6306 49.8632ZM49.9054 5.43707V49.8632H5.44166L49.9054 5.43707ZM23.4358 52.1169H49.9054V78.5641C35.5653 77.9838 24.011 66.4392 23.4358 52.1169Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKinetic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kinetic.3dd9f68a.svg";
export { ForwardRef as ReactComponent };